// extracted by mini-css-extract-plugin
module.exports = {"downloadFlex":"Dashoboard_downloadFlex__1dJ-Y","bg":"Dashoboard_bg__20bWA","container1":"Dashoboard_container1__1-9Uu"};